<app-loading-panel [show]="company == null"></app-loading-panel>

@if (company != null) {
  <section class="pc-dutchie-page">
    <header class="pc-dutchie-header">
      <div class="pc-dutchie-header__copy">
        <div class="pc-title-row">
          <h2>Dutchie integration</h2>
          <span class="pc-status-badge" [class.pc-status-badge--active]="company.leaflogix.active">
            <span></span>{{ company.leaflogix.active ? 'Active' : 'Inactive' }}
          </span>
        </div>
        <p>Connect Dutchie to keep strains and rooms in sync with PlanaCan.</p>
      </div>

      <div class="pc-dutchie-header__actions">
        <button mat-stroked-button [disabled]="!dataUpdated() || saving" (click)="get()">
          <mat-icon>undo</mat-icon>
          Discard
        </button>
        <button mat-raised-button color="primary" [disabled]="!dataUpdated() || saving" (click)="save()">
          @if (saving) {
            <mat-spinner diameter="18" strokeWidth="3"></mat-spinner>
          } @else {
            <mat-icon>save</mat-icon>
          }
          {{ saving ? 'Saving…' : 'Save changes' }}
        </button>
      </div>
    </header>

    <div class="pc-integration-card">
      <div class="pc-connection-row">
        <div class="pc-dutchie-mark" aria-hidden="true"><mat-icon>sync_alt</mat-icon></div>
        <div class="pc-connection-row__copy">
          <strong>Use Dutchie</strong>
          <span>Enable the connection for this company workspace.</span>
        </div>
        <mat-slide-toggle name="leaflogixactive" [(ngModel)]="company.leaflogix.active" aria-label="Enable Dutchie integration"></mat-slide-toggle>
      </div>

      <div class="pc-integration-divider"></div>

      <div class="pc-config-heading">
        <h3>Connection details</h3>
        <p>Enter your Dutchie API credentials and choose who can administer the integration.</p>
      </div>

      <div class="pc-config-grid">
        <mat-form-field appearance="outline">
          <mat-label>API key</mat-label>
          <input autocomplete="off" matInput [type]="apiKeyHide ? 'password' : 'text'" [(ngModel)]="company.leaflogix.apiKey">
          <button type="button" mat-icon-button matSuffix (click)="apiKeyHide = !apiKeyHide" [attr.aria-label]="apiKeyHide ? 'Show API key' : 'Hide API key'">
            <mat-icon>{{apiKeyHide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-hint>Your key is stored securely and is never shown by default.</mat-hint>
        </mat-form-field>

        <div class="pc-admin-field">
          <span class="pc-admin-field__label">Dutchie administrators</span>
          <app-user-select-multiple
            [placeholder]="'Select administrators'"
            [displayUserList]="false"
            [(userIds)]="company.leaflogix.adminUserIds">
          </app-user-select-multiple>
          <span class="pc-admin-field__hint">These users can manage Dutchie-related configuration.</span>
        </div>
      </div>

      <div class="pc-sync-note">
        <mat-icon>info_outline</mat-icon>
        <div>
          <strong>What happens when you connect?</strong>
          <span>After saving a new or updated connection, you can run an initial sync. Dutchie strains and rooms will replace the corresponding data currently stored in PlanaCan.</span>
        </div>
      </div>
    </div>
  </section>
}
